<ng-container *ngIf="operation$ | async as operation">
  <x-shop-dialog
    *ngIf="data"
    [canClose]="data.closeDialog"
    [heading]="data.title"
    (closeDialog)="closeDialog()"
    [loading]="operation.status === 'loading'"
  >
    <span class="text-center" [innerHTML]="data.message"></span>

    <!--actions-->
    <x-shop-dialog-actions *ngIf="data.actions.length">
      <ng-container xAction *ngFor="let action of data.actions; trackBy: 'label' | trackBy">
        <ng-container [ngSwitch]="action.buttonType">
          <button
            *ngSwitchCase="'secondary'"
            mat-stroked-button
            color="primary"
            (click)="closeAction(action)"
          >
            {{ action.label }}
          </button>
          <button *ngSwitchDefault mat-flat-button color="primary" (click)="closeAction(action)">
            {{ action.label }}
          </button>
        </ng-container>
      </ng-container>
    </x-shop-dialog-actions>
  </x-shop-dialog>
</ng-container>
